export default {
  resource:{
    zh: {
      title:"原始打卡记录",
      companyNo:"公司",
      xdate: "日期",
      rq1: "开始日期",
      rq2: "结束日期", 
      deptNo: "部门",
      deptName: "部门",
      empId:	"工号",
      empName:	"姓名",
      dcId:"考勤机号",
      vfyModel:"打卡方式",
      vfyModel0:"密码",
      vfyModel1:"指纹",
      vfyModel2:"磁卡",
      vfyModel4:"磁卡",
      vfyModel15:"人脸",
      vfyModelElse:"其他",
      xtime:"时间"
    }
  },
  delConf:["empName"],
  isShowMore: true,
  params: {
    companyNo:{
      key: "companyNo",
      defaultIdx: 0,
      method: "Equal",
      type: "select",
      options:"company"
    },
    dept:{
      key: "deptNo",
      data: "",
      more: true,
      method: "Equal",
      type: "select",
      options:[{
        value: "",
        text: "All"
      }]
    },
    rq1:{
      key: "xdate",
      tkey: "rq1",
      data: null,
      method: "GreaterThanOrEqual",
      type: "date"
    },
    rq2:{
      key: "xdate",
      tkey: "rq2",
      data: null,
      method: "LessThanOrEqual",
      type: "date"
    },
    bh:{
      key: "empId",
      data: null,
      method: "Equal",
      more:"true",
      type: "text"
    },
    xm:{
      key: "empName",
      data: null,
      method: "Contains",
      more:"true",
      type: "text"
    }
  },
  listDefine: [
    "empId","empName","deptName",
    {key: "xdate",formatter: "fdate"},{key: "xtime", formatter: "ftime"},"dcId", {key:"vfyModel", formatter:"fmodel"}
  ],
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  defaultSortName: "xdate",
  defaultSortOrder: "asc",
  sortName: "xdate",
  sortOrder: "asc",
  sorts:[{key: "empName", value: "asc"}, {key: "xdate", value: "desc"}],
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  url:"OriginalRecord/",
  formatter:{
    fmodel(v){
      if (v==0) return "vfyModel0"
      else if (v==1) return "vfyModel1"
      else if (v==2) return "vfyModel2"
      else if (v==4) return "vfyModel4"
      else if (v==15) return "vfyModel15"
      else if (v) return "vfyModelElse"
    }
  }

}
